import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';

export const AdminJobsReportPage = () => {
  return (
    <>
      <Helmet>
        <title>Jobs Report - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
